export default __webpack_public_path__ + "b98e329f47f1369e580fca818c2d7794.svg";